import { Component, OnInit, Input, HostListener, WritableSignal, signal } from '@angular/core';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { Observable } from 'rxjs';
import { MixedLoyaltyQuery, MixedLoyaltyItem } from '@fgb/core';
import { map, tap } from 'rxjs/operators';
import { OwlCarouselSettings } from '@fgb/portal-component-library/src/lib/shared/utilities';
enum RewardWidth {
  Destop = 302,
  Tablet = 194,
  Mobile = 165,
}
@Component({
  selector: 'fgbcl-featured-rewards',
  templateUrl: './featured-rewards.component.html',
  styleUrls: ['./featured-rewards.component.scss'],
})
export class FeaturedRewardsComponent implements OnInit {
  @Input() take?: number;
  @Input() showAllPath = '/rewards';
  @Input() title: string;
  @Input() featuredIcon: string = 'star';
  @Input() showTitleIcon: boolean = false;
  rewardsWidth: number | string;
  mixedLoyaltyItems$: Observable<MixedLoyaltyItem[] | null>;
  isDragging: boolean = false;
  customOptions: WritableSignal<OwlOptions> = signal({
    margin: OwlCarouselSettings.Margin,
    autoWidth: true,
    loop: true,
    pullDrag: false,
    autoplay: OwlCarouselSettings.Autoplay,
    autoplayTimeout: OwlCarouselSettings.AutoplayTimeout,
    autoplaySpeed: OwlCarouselSettings.AutoplaySpeed,
    navSpeed: 700,
    navText: ['', ''],
    responsive: {
      0: { items: 2 },
      540: { items: 2 },
      740: { items: 3 },
    },
    dots: true,
  });

  constructor(private mixedLoyaltyService: MixedLoyaltyQuery) {}

  @HostListener('window:resize', ['$event'])
  onWindowResize(event: any) {
    this.setRewardsWidth(event?.target.screen.width);
  }

  ngOnInit() {
    this.setRewardsWidth(window.screen.width);

    this.mixedLoyaltyItems$ = this.mixedLoyaltyService.selectFavouriteMixedLoyaltyItems().pipe(
      map((items) => (items ? items.slice(0, this.take) : null)),
      tap((items) => (items ? (items.length < 3 ? this.setLoop(false) : this.setLoop(true)) : this.setLoop(false)))
    );
  }

  setRewardsWidth(screenSize: number) {
    if (screenSize >= 992) this.rewardsWidth = RewardWidth.Destop;
    if (screenSize < 992 && screenSize >= 425) this.rewardsWidth = RewardWidth.Tablet;
    if (screenSize < 425) this.rewardsWidth = RewardWidth.Mobile;
  }

  setLoop(value: boolean) {
    this.customOptions.update((state) => ({ ...state, loop: value }));
  }
}
